<div class="qa-row">
  <app-custom-select
    class="qa-select"
    [options]="options"
    bindValue="value"
    bindLabel="label"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [ngModel]="value"
    (ngModelChange)="onSelectChange($event)">
  </app-custom-select>

  <button *ngIf="showAdd" type="button" class="qa-add" (click)="openModal()" [disabled]="disabled"
          aria-label="Manage options" title="Add / remove options">+</button>
</div>

<div class="qa-overlay" *ngIf="modalOpen" (click)="closeModal()">
  <div class="qa-modal" (click)="$event.stopPropagation()">
    <div class="qa-modal__head">
      <span>Manage options</span>
      <button type="button" class="qa-x" (click)="closeModal()" aria-label="Close">&times;</button>
    </div>

    <div class="qa-modal__body">
      <label class="qa-label">Add value <span class="qa-req">*</span></label>
      <input class="qa-input" type="text" [(ngModel)]="newValue" placeholder="Enter new value"
             (keyup.enter)="saveNew()" autofocus>

      <div class="qa-existing" *ngIf="options.length">
        <div class="qa-existing__item" *ngFor="let o of options">
          <span class="qa-existing__label">{{ o.label }}</span>
          <button *ngIf="o.id" type="button" class="qa-del" [disabled]="busyId === o.id"
                  (click)="deleteOption(o, $event)" aria-label="Remove option" title="Remove">
            &times;
          </button>
          <span *ngIf="!o.id" class="qa-default" title="Built-in default">default</span>
        </div>
      </div>
    </div>

    <div class="qa-modal__foot">
      <button type="button" class="qa-btn qa-btn--primary" (click)="saveNew()" [disabled]="saving">
        {{ saving ? 'Saving…' : 'Done' }}
      </button>
      <button type="button" class="qa-btn" (click)="closeModal()">Cancel</button>
    </div>
  </div>
</div>
